import ViewsAuthLogin from '@/views/auth/ViewsAuthLogin.vue';
import ViewsAuthLogout from '@/views/auth/ViewsAuthLogout.vue';
import ViewsAuthConfirm from '@/views/auth/ViewsAuthConfirm.vue';
import ViewsAuthLoginSso from '@/views/auth/ViewsAuthLoginSso.vue';
import {AUTOLOGIN_ENABLED} from '@/constants';
import {RouteRecordRaw} from 'vue-router';
import {RouterMetaProcessorResult} from '@/global/types/router';

export default [
    {
        path: '/login',
        name: 'auth.login',
        component: ViewsAuthLogin,
        meta: {
            requiresGuest: true,
            requiresRedirect: (): RouterMetaProcessorResult => AUTOLOGIN_ENABLED ? {name: 'home'} : null,
        }
    },
    {
        path: '/logout',
        name: 'auth.logout',
        component: ViewsAuthLogout,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/confirm-email',
        name: 'auth.confirm',
        component: ViewsAuthConfirm,
        meta: {
            requiresGuest: true
        }
    },
    {
        path: '/login/sso',
        name: 'auth.sso',
        component: ViewsAuthLoginSso,
        meta: {
            requiresGuest: true
        }
    }
] as RouteRecordRaw[];